import React, { Component } from 'react';
import { connect } from 'react-redux';
import AppointmentCard from '../../screens/Appointments/components/AppointmentCard';
import CancellationPolicyModal from '../../screens/Book/components/CancellationPolicyModal';
import ModalCancelResched from '../../screens/ModalCancelResched';
import './styles.scss';
import { TimeSlot, AppointmentType, Appointment, Patient, ReduxState } from 'kb-shared';
import { RouteComponentProps, withRouter } from 'react-router';

interface Props extends RouteComponentProps<{}> {
  timeSlot: TimeSlot | null;
  type: AppointmentType;
  isConfirmation: boolean;
  isPartOfPackage?: boolean;
  appointment: Appointment;
  onAppointmentCancelled?: Function;
  onReturnToDashboard?: Function | null;
  onReschedule: Function;
  patient?: Patient;
  hasStepper?: boolean;
  currentLabTimeZone?: string;
}

type State = {
  showModal: boolean;
  FF_RESCHEDULE_CANCEL: boolean;
};

// TODO: Add alternative PHONE icon from APPOINTMENT
class UpcomingAppointment extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showModal: false,
      FF_RESCHEDULE_CANCEL: true
    };
  }

  componentDidMount() {
    if (window.analytics) {
      window.analytics.page('Confirmation');
      window.analytics.page('Appointments');
    }
  }

  _handleButton = () => {
    this.props.history.replace('/');
  };

  toggleCancelModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  returnToDashboard = () => {
    if (this.props.onReturnToDashboard) {
      this.props.onReturnToDashboard();
    } else {
      this.toggleCancelModal();
    }
  };

  renderModal() {
    // If appointment is not cancelable or reschedulable, display an informational modal to user
    // OR if feature is turned off
    const appointment = this.props.appointment;

    if (!this.state.FF_RESCHEDULE_CANCEL) {
      return (
        <CancellationPolicyModal
          show={this.state.showModal}
          onClickClose={this.toggleCancelModal}
          appointment={appointment}
        />
      );
    }

    // Otherwise display the actual cancel/reschedule modal
    return (
      <ModalCancelResched
        visible={this.state.showModal}
        onClose={this.toggleCancelModal}
        onReturnToDashboard={this.returnToDashboard}
        appointment={appointment}
        onAppointmentCancelled={this.props.onAppointmentCancelled}
        onReschedule={this.props.onReschedule}
      />
    );
  }

  render() {
    const {
      type,
      isConfirmation,
      isPartOfPackage,
      appointment,
      patient,
      currentLabTimeZone
    } = this.props;
    return (
      <div className="consult__question--animated" style={{ width: '100%' }}>
        <div hidden id="hidden-user-id">
          {patient && patient.id}
        </div>
        {isConfirmation && !isPartOfPackage && (
          <React.Fragment>
            <div hidden className="appt-confirm-page">
              true
            </div>
            <div hidden className="hidden-appt-id">
              {appointment.id}
            </div>
            <div hidden className="hidden-price">
              {type.rateCents / 100}
            </div>
            <div hidden className="hidden-appt-type-id">
              {type.id}
            </div>
          </React.Fragment>
        )}
        <AppointmentCard
          toggleModal={this.toggleCancelModal}
          type={{ ...this.props.appointment, ...this.props.type }}
          {...this.props.appointment}
          timeZone={currentLabTimeZone || this.props.appointment.timeZone}
          hasStepper={this.props.hasStepper}
        />
        {this.renderModal()}
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  currentLabTimeZone: state.patient.patient.preferredTimezone || state.patient.patient.lab?.timeZone
});

export default withRouter(connect(mapStateToProps)(UpcomingAppointment));
